import { Mongo } from 'meteor/mongo';

export const OperatorAccountsCollection = new Mongo.Collection('operatorAccounts');
export const OperatorMembershipsCollection = new Mongo.Collection('operatorMemberships');

export const OPERATOR_ROLES = Object.freeze({
  OWNER: 'owner',
  ADMIN: 'admin',
  MEMBER: 'member',
});

export const OPERATOR_ROLE_VALUES = Object.freeze(Object.values(OPERATOR_ROLES));
